import * as types from '../actions/actionTypes';
import initialState from './initialState';
import { updateableReducer, newMapWith, replaceInMap } from './common';
import Operation from '../models/Operation';
import { isUndefinedNullOrEmpty } from '../utils';

const createOperation = (id, jsonOperation) => {
    return new Operation(id, jsonOperation.type, jsonOperation.status.state, jsonOperation.timestamp, jsonOperation.startedByUser, jsonOperation.status.lastError);
};

const newMapWithExtractedOperation = (map, obj) => {
    if (isUndefinedNullOrEmpty(obj.latestOperation)) { return map; }
    return replaceInMap(map, obj.latestOperation.id, createOperation(obj.latestOperation.id, obj.latestOperation.value));
};

const operationsReducerFactory = (actionType) => {
    switch(true) {
        case actionType === types.SQL_SERVER_INSTANCE_STATUS_REQUESTED || actionType === types.BACKUP_LOCATION_VALIDATION_REQUESTED || actionType === types.IMAGE_LOCATION_VALIDATION_REQUESTED:
            return (stateValue, actionValue) => {
                const { id, value } = actionValue;
                return newMapWith(stateValue, id, createOperation(id, value));
            };

        case actionType === types.IMAGES_UPDATED || actionType === types.CLONES_UPDATED:
            return (stateValue, actionValue) => {
                let newMap = stateValue;
                for(const obj of actionValue) {
                    newMap = newMapWithExtractedOperation(newMap, obj);
                }
                return newMap;
            };

        case actionType === types.CLONE_CREATION_UPDATED:
            return (stateValue, actionValue) => {
                const { clone } = actionValue;
                return newMapWithExtractedOperation(stateValue, clone);
            };

       case actionType === types.IMAGE_CREATION_UPDATED:
            return (stateValue, actionValue) => {
                const { image } = actionValue;
                return newMapWithExtractedOperation(stateValue, image);
            };

        case actionType === types.CLONE_DELETION_UPDATED || actionType === types.IMAGE_DELETION_UPDATED:
             return (stateValue, actionValue) => {
                if (!actionValue.operation) { return stateValue; }
                const { operationId, operation } = actionValue;
                return newMapWith(stateValue, operationId, createOperation(operationId, operation));
            };

        case actionType === types.OPERATION_STATUS_UPDATED:
            return (stateValue, actionValue) => {
                const { id, status } = actionValue;
                const operationToUpdate = stateValue.get(id);
                if(!isUndefinedNullOrEmpty(operationToUpdate)) {
                    const updatedOperation = new Operation(id, operationToUpdate.type, status.state, operationToUpdate.startedAt, operationToUpdate.startedBy, status.lastError); 
                    const newMap = new Map([...stateValue]);
                    newMap.delete(id);
                    newMap.set(id, updatedOperation);
                    return newMap;
                } else {
                    return stateValue;
                }
            };

        case actionType === types.SQL_SERVER_INSTANCE_STATUS_COMPLETED || actionType === types.BACKUP_LOCATION_VALIDATION_COMPLETED || actionType === types.IMAGE_LOCATION_VALIDATION_COMPLETED:
            return (stateValue, actionValue) => {
                const operationToUpdate = stateValue.get(actionValue.operationId);
                if(!isUndefinedNullOrEmpty(operationToUpdate)) {
                    const updatedOperation = { ...operationToUpdate, resultDetails: actionValue };
                    const newMap = new Map([...stateValue]);
                    newMap.delete(actionValue.operationId);
                    newMap.set(actionValue.operationId, updatedOperation);
                    return newMap;
                } else {
                    return stateValue;
                }
            };

        default:
            return null;
    }
};

export default updateableReducer(operationsReducerFactory, initialState.operations);



// WEBPACK FOOTER //
// ./src/js/reducers/operationsReducer.js